export default [
  {
    path: "/resources",
    name: "resources",
    permission: "access_resources",
    component: () => import("@/views/lms/index"),
    meta: { permission: ['access_resources'], pageTitle: "LMS", breadcrumb: [{ text: "LMS", active: true }] },
  },
];
